(function () {
    'use strict';

    angular
        .module('app.application.role')
        .controller('RoleEditController', RoleEditController);

    /* @ngInject */
    function RoleEditController(
        logger,
        roleService,
        applicationService,
        $uibModalInstance,
        role,
        $q,
        $filter) {
        //Private Variables
        var vm = this;
        var applications = [];

        //Public Variables
        vm.title = 'Edit Role';
        vm.role = role;

        //Public Methods
        vm.save = save;
        vm.reset = reset;

        //Activate Controller
        activate();

        function activate() {
            var promises = [getApplications()];
            return $q.all(promises).then(function () {
                setForm(applications);
                logger.info('Activated role Edit View');
            });
        }

        function save() {
            if (vm.roleForm.$valid) {
                roleService.saveRole(vm.role)
                    .then(function (result) {
                        if (result.status === 200) {
                            var application = $filter('filter')(
                                vm.roleFields[2].templateOptions.options, {
                                    ApplicationId: result.data.ApplicationId
                                }, true);

                            vm.role.Application = application[0];
                            $uibModalInstance.close(vm.role);
                        } else {
                            logger.info('issue saving role');
                        }
                    });
            }
        }

        function reset() {
            vm.roleForm.options.resetModel();
            $uibModalInstance.dismiss('cancel');
        }

        function getApplications() {
            return applicationService.getApplications()
                .then(function (result) {
                    applications = result;
                });
        }

        function setForm(applications) {
            vm.roleFields = roleService.getRoleFields(vm.role.ApplicationId, applications);
        }
    }
})();
